import { render, staticRenderFns } from "./FormField.vue?vue&type=template&id=2a80a44f&scoped=true&"
import script from "./FormField.vue?vue&type=script&lang=js&"
export * from "./FormField.vue?vue&type=script&lang=js&"
import style0 from "./FormField.vue?vue&type=style&index=0&id=2a80a44f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a80a44f",
  null
  
)

export default component.exports